/**

 * Authorization claim prefix for the Order Integration Control (Controle de

 * Integração de OS) feature — menu grouping under Configuração › MaxProcess (RN-03).

 *

 * Security contract (stable): `WO-ORDER-CONTROLS-R` / `WO-ORDER-CONTROLS-W`.

 * MaxProcess is a navigation/i18n label only; it does not introduce separate claims.

 */





export const _CLAIMS_SYS_ADMIN = ['ADMIN','SYS-ADMIN'] as const;
export const _CLAIMS_ADMIN = ['ADMIN','SYS-ADMIN'] as const;





